<template>
    <!--WWW-2163: Replaced the checkbox with the DSEText
    <ValidationProvider name="dseValidation" rules="checkboxChecked" v-slot="{ errors }" slim>
        <div class="migrol-form__input-wrapper" :class="{ 'migrol-form__input-wrapper--error' : errors.length > 0 }">
            <Checkbox type="checkbox" v-model="innerValue" v-on="inputListeners">
                <DSEText />
            </Checkbox>
            <div class="migrol-form__error-message">{{Strings['Global.AGBDSE.ErrorDseNotAccepted']}}</div>
        </div>
    </ValidationProvider>-->
    <DSEText />
</template>

<script>
    //import { ValidationProvider } from 'VeeValidate';
    import DSEText from './DSEText';

    export default {
        props: {
            value: {
                //WWW-2163 default to true now, so server side validation does not kick in
                //default: false
                default: true
            }
        },
        model: {
            event: 'change'
        },
        computed: {
            Strings() {
                return this.$migrolVueLibraryData.Strings;
            }
        },
        data() {
            return {
                innerValue: null
            }
        },
        watch: {
            value:
            {
                immediate: true,
                handler(newValue) {
                    this.innerValue = newValue;
                }
            },
            innerValue(newValue) {
                this.$emit('change', newValue);
            }
        },
        components: {
            //ValidationProvider,
            DSEText
        }
    };
</script>